import { InboxOutlined } from '@ant-design/icons';
import { App, Upload, type UploadProps } from 'antd';
import type { UploadFile } from 'antd/lib/upload';

import { fileUploaderLib } from '..';

const { Dragger } = Upload;

interface Props extends UploadProps {
  files?: UploadFile[];
  setFiles?: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  hintMessage?: string;
  allowTypes?: string[];
}

const FileUploader = ({ files, setFiles, name, hintMessage, allowTypes, ...props }: Props) => {
  const { message } = App.useApp();
  const beforeUpload: UploadProps['beforeUpload'] = (file, incomingFiles) => {
    if (allowTypes && !allowTypes.includes(file.type)) {
      message.error(`Неверный формат файла: ${file.type}`);
      return Upload.LIST_IGNORE;
    }

    setFiles &&
      setFiles((prev) =>
        prev
          .filter((prevFile) => !incomingFiles.find((i) => i.name === prevFile.name))
          .concat([...incomingFiles])
      );
    return false;
  };

  const onRemove: UploadProps['onRemove'] = (file) => {
    if (files && setFiles) {
      const index = files.indexOf(file);
      const newFileList = files.slice();
      newFileList.splice(index, 1);
      setFiles(newFileList);
    }
  };

  return (
    <>
      <Dragger
        {...fileUploaderLib.config}
        fileList={files}
        beforeUpload={beforeUpload}
        onRemove={onRemove}
        {...props}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p id="me-upload-avatar-modal-description-text" className="ant-upload-text">
          Выберите или перенесите фото в эту зону
        </p>
        <div>
          {hintMessage && <p className="ant-upload-hint">{hintMessage}</p>}
          <p className="ant-upload-hint">- Поддерживаемые типы JPG,PNG, WEBP</p>
        </div>
      </Dragger>
    </>
  );
};

export default FileUploader;
